import Loadable from "../../components/Loadable";
import { lazy } from "react";
import { FINANCIAL_REPORTS } from "../../utils/constant";

const ExpenseManagement = Loadable(lazy(() => import("./ExpenseManagement")));
const FinancialReports = Loadable(lazy(() => import("./FinancialReports")));

const financialRoutes = [
  {
    path: "/financial/expenses",
    element: <ExpenseManagement />,
    permission: FINANCIAL_REPORTS,
  },
  {
    path: "/financial/reports",
    element: <FinancialReports />,
    permission: FINANCIAL_REPORTS,
  },
];

export default financialRoutes;